module.exports = __webpack_public_path__ + "assets/img/arrow-left.bde5d882.svg";